var map = {
	"./b01.jpg": "IF2i",
	"./b02.jpg": "ckUX",
	"./b03.jpg": "cHuK",
	"./b04.jpg": "l/vN",
	"./b05.jpg": "l1io",
	"./b06.jpg": "78sk",
	"./b07.jpg": "9JW6",
	"./b08.jpg": "rYPQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L+QI";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*$
// module id = L+QI
// module chunks = 1